import { useState } from 'react';
import { IoChevronDown, IoChevronUp } from 'react-icons/io5';
import { Dropdown, type DropDownProps } from 'antd';
import { StyledButton, type StyledButtonProps } from '@app/components/button/Button';
import type { ReactNode } from 'react';
import type { ItemType } from 'antd/es/menu/interface';
import type { AnyObject } from 'antd/es/_util/type';

export type ActionsDropdownProps = DropDownProps & {
    title: ReactNode;
    items: ItemType[];
    data?: AnyObject;
    disabled?: boolean;
    buttonProps?: StyledButtonProps;
};

export const ActionsDropdown = ({
    items = [],
    title = '',
    data = {},
    disabled = false,
    buttonProps,
    menu,
    ...props
}: ActionsDropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);

    // Change dropdown icon depending on open state
    const DropdownIcon = isOpen ? IoChevronUp : IoChevronDown;

    return (
        <Dropdown
            {...props}
            classNames={{ root: 'styled-dropdown' }}
            menu={{
                ...menu,
                items,
                onClick: () => setIsOpen(false), // close menu on click
                style: {
                    minWidth: 100,
                },
            }}
            trigger={['click']}
            onOpenChange={(open) => setIsOpen(open)}
            disabled={disabled}>
            <StyledButton
                type="primary"
                data-testid={`actions-dropdown-button-${data?.id}`}
                icon={<DropdownIcon size="14" style={{ display: 'block' }} />}
                iconPlacement="end"
                {...buttonProps}>
                {title}
            </StyledButton>
        </Dropdown>
    );
};
